__turbopack_context__.v({
  "container": "HgKp1W_container",
  "image": "HgKp1W_image",
  "imagePlaceholder": "HgKp1W_imagePlaceholder",
  "ratingContainer": "HgKp1W_ratingContainer",
  "username": "HgKp1W_username",
});
